import type { ComponentType } from 'react'
import { isSameDay } from 'date-fns'

import type {
	SchedulerCalendarEvent,
	SchedulerCalendarEventComponentProps,
} from './types'

export const WeekAllDayRow = ({
	days,
	allDayEvents,
	gridTemplateColumns,
	selectedEventId,
	setSelectedEventId,
	EventComponent,
	onSelectEvent,
}: {
	days: Date[]
	allDayEvents: SchedulerCalendarEvent[]
	gridTemplateColumns: string
	selectedEventId: string | null
	setSelectedEventId: (id: string) => void
	EventComponent: ComponentType<SchedulerCalendarEventComponentProps>
	onSelectEvent?: (event: SchedulerCalendarEvent) => void
}) => {
	if (allDayEvents.length === 0) return null

	return (
		<div className='border-border/70 bg-muted/10 border-b'>
			<div
				className='grid'
				style={{ gridTemplateColumns }}
			>
				<div className='border-border/70 relative shrink-0 border-r'>
					<span className='text-muted-foreground/70 absolute bottom-0 left-0 flex h-6 w-full items-center justify-end pe-2 text-right text-[10px] sm:pe-4 sm:text-xs'>
						All day
					</span>
				</div>

				{days.map((day) => {
					const dayAllDayEvents = allDayEvents.filter((event) => {
						return (
							isSameDay(day, event.start) ||
							(day > event.start && day < event.end) ||
							isSameDay(day, event.end)
						)
					})

					return (
						<div
							className='border-border/70 relative border-r p-1 last:border-r-0'
							data-today={isSameDay(day, new Date()) || undefined}
							key={day.toString()}
						>
							{dayAllDayEvents.map((event) => {
								const selected = selectedEventId === event.id

								return (
									<div
										className='mb-1'
										data-scheduler-event='true'
										key={event.id}
									>
										<EventComponent
											event={event}
											onSelect={(selectedEvent) => {
												setSelectedEventId(selectedEvent.id)
												onSelectEvent?.(selectedEvent)
											}}
											selected={selected}
											variant='allDay'
											view='week'
										/>
									</div>
								)
							})}
						</div>
					)
				})}
			</div>
		</div>
	)
}
